module.exports = __webpack_public_path__ + "static/media/video-thumbnail.d5d633ea.JPG";